import React, { useEffect, useState } from 'react';
import { obtenerTodosUsuarios } from '../../../../../actions/user/user.actions';
import { listaUsuarios } from '../../../../../models/usuarios/usuarios.models';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { RutasPrivadas } from '../../../../../routes/rutasPrivadas/rutasPrivadas';

export type NuevosUsuariosScreenProps = {
	// types...
}

const NuevosUsuariosScreen: React.FC<NuevosUsuariosScreenProps> = ({ }) => {
	const [listaUsuarios, setListaUsuarios] = useState<listaUsuarios[]>([]);
	const navigate = useNavigate();

	async function obtenerUsuariosAsync() {
		try {
			const resp = await obtenerTodosUsuarios();
			let usuarios: listaUsuarios[] = resp.data;
			let listaUsuariosFiltrada: listaUsuarios[] = usuarios.filter((usuario) => (!usuario.datosCompletos /*|| !usuario.datosCompletosEmpresaDefault || !usuario.empresaRegistrada*/));
			setListaUsuarios(listaUsuariosFiltrada);
		} catch (err) {
			console.error(err);
		}
	}

	function navegarA(idUsuario: number) {
		navigate(`${RutasPrivadas.DATOS_USUARIO}/${idUsuario}/registro`)
	}

	useEffect(() => {
		obtenerUsuariosAsync();
	}, [])

	return (
		<div className='flex flex-col gap-4 p-5 bg-white w-full border shadow-xl rounded-xl h-[85%] overflow-y-hidden'>
			{/* title */}
			<div>
				<div className='flex flex-row gap-2 justify-between pl-2'>
					<p className='font-medium lg:text-2xl md:text-lg text-base text-DegradatedText'>
						Usuarios con datos incompletos.
					</p>
				</div>
			</div>
			{/* content */}
			<div className='flex gap-2 overflow-y-auto'>
				<div className={`max-h-full overflow-auto m-2 pt-2 w-full border`}>
					<table className='table table-zebra border-DarkBlue table-md table-pin-rows table-pin-cols bg-white text-center'>
						<thead>
							<tr className='text-black'>
								<th>ID Elsa</th>
								<th>Nombre</th>
								<th>Apellidos</th>
								<th>Correo</th>
								<th>Registro finalizado</th>
								<th>Acciones</th>
							</tr>
						</thead>
						<tbody>
							{
								listaUsuarios.length > 0 && listaUsuarios.map(
									(usuario, index) => (
										<tr key={index}>
											<td>
												{usuario.idUsuarioElsa}
											</td>
											<td>
												{usuario.nombreCompleto}
											</td>
											<td>
												{usuario.primerApellido}
											</td>
											<td>
												{usuario.correo}
											</td>
											<td className={`p-2`}>
												<p className=' font-semibold text-black'>
													{usuario.datosCompletos && usuario.empresaRegistrada && usuario.datosCompletosEmpresaDefault
														? 'Registro finalizado' :
														usuario.datosCompletos && !usuario.empresaRegistrada && !usuario.datosCompletosEmpresaDefault
														 ? 'Requiere finalizar el registro de datos de empresas' :
														 'Requiere realizar registro de datos y empresas' }
												</p>
											</td>
											<td className='flex flex-row gap-4 items-center justify-center text-base'>
												<button onClick={() => navegarA(usuario.idUsuarioElsa)}>
													<FontAwesomeIcon icon={faEdit} />
												</button>
											</td>
										</tr>
									)
								)
							}
						</tbody>
					</table>
					{
						listaUsuarios.length === 0 && (
							<div className='flex justify-center pt-5'>
								<h1 className='font-semibold text-xl'> Sin información</h1>
							</div>
						)
					}
				</div>
			</div>
		</div>
	);
};

export default NuevosUsuariosScreen;
